module.exports = __webpack_public_path__ + "img/dsci0152.4715e4da.jpg";